import React, { Component, Fragment } from 'react';
import YouTube from 'react-youtube';
import SequenceList from './SequenceList';
import { WORKOUT_ADDED_MESSAGE } from '../../static-content';
import { COLORS } from '../../styles/colors';
import AlertMessage from '../AlertMessage';
import { getTimeFormat } from './../../helpers';


/**
 * Info
 */
export class Info extends Component {
	// eslint-disable-line react/prefer-stateless-function
	state = {
		dataLoaded: false,
		workout: null,
	};
	componentDidMount() {
		this.props.fetchInfo().then(data => {
			this.setState({
				...this.state,
				dataLoaded: true,
				workout: data,
				isGetImage: false,
				screenShotUrl: '',
			});
		});
	}

	componentWillUnmount() {
		this.props.resetWorkoutInfo();
	}

	getProgramLevel(level) {
		switch (String(level)) {
			case '1':
				return 'Beginner';
			case '2':
				return 'Intermediate';
			case '3':
				return 'Advanced';
			default:
				return '';
		}
	}

	changeParentImage = plan => {
		const { isGetImage, workout } = this.state;
		if (!isGetImage && !workout.youtubeLink) {
			const imagePath = plan && plan.exercise && plan.exercise[0].screenShotUrl;
			this.setState(
				{
					isGetImage: true,
					screenShotUrl: imagePath,
				},
				() => this.props.updateWorkoutImg(workout._id, imagePath)
			);
		}
	};

	renderImage(workout, screenShotUrl) {
		if(!workout.youtubeLink) {
			if (workout.imgUrl) {
				return (
					<img
						src={workout.imgUrl}
						alt={workout.name}
						style={{ width: '100%', height: 200, objectFit: 'fill' }}
					/>
				);
			} else {
				return (
					<img
						src={screenShotUrl}
						alt={workout.name}
						style={{ width: '100%', height: 200, objectFit: 'fill' }}
					/>
				);
			}
		}
	}

	_onReady(event) {
		// access to player in all event handlers via event.target
		event.target.pauseVideo();
	}

	getYoutubeId(url){
		url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
		return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
	}

	render() {
		const { dataLoaded, workout, screenShotUrl } = this.state;
		const { workoutCats, planNotes, isViewNotes } = this.props;
		let videoId;
		if(workout && workout.youtubeLink) {
			videoId = this.getYoutubeId(workout.youtubeLink);
		}
		const opts = {
			height: '200',
			width: '320',
			playerVars: {
			  // https://developers.google.com/youtube/player_parameters
			  autoplay: 1,
			},
		  };
		const queryParams = this.props.location
			? new URLSearchParams(this.props.location.search)
			: null;
		const showMessage = queryParams ? queryParams.get('new') : false;
		if (dataLoaded) {
			const { sequences, circuits, plans } = workout.info;
			const category = Object.values(workoutCats).filter(
				cat => cat._id === workout.categoryId
			)[0];
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					{showMessage ? (
						<AlertMessage
							subject="Workout added!"
							body={WORKOUT_ADDED_MESSAGE}
							icon={['far', 'check-square']}
						/>
					) : null}
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							width: '100%',
						}}
					>
					{!workout.youtubeLink && workout.imgUrl &&
						(workout.imgUrl.includes('.mp4') ||  workout.imgUrl.includes('.quicktime') || workout.imgUrl.includes('.MOV'))  ? (
							<video
								src={workout.imgUrl}
								controls
								style={{ width: '100%', height: 200, objectFit: 'fill' }}
								autoPlay
								loop
								muted
							/>
						) : (
							<Fragment>{this.renderImage(workout, screenShotUrl)}</Fragment>
					)}
					{workout.youtubeLink &&
						<YouTube videoId={videoId} opts={opts} onReady={this._onReady} />
					}
					</div>
					<div
						style={{
							backgroundColor: COLORS.greyFour,
							padding: 10,
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									width: 'fit-content',
									background: COLORS.greyThree,
									borderRadius: 2,
									padding: '3px 5px',
									color: COLORS.greyFour,
								}}
							>
								{category.name}
							</div>
							<div
								style={{
									fontWeight: 'bold',
									textAlign: 'center',
								}}
							>
								{workout.name}
							</div>
							<div
								style={{
									color: COLORS.orange,
								}}
							>
								{`${getTimeFormat(workout.duration)} | ${
									workout.price ? `$` + workout.price : 'FREE'
								} | ${this.getProgramLevel(workout.level)}`}
							</div>
							<div
								style={{
									fontWeight: 'bold',
									marginTop: 10,
								}}
							>
								Description
							</div>
							<div
								style={{
									textAlign: 'left',
									wordBreak: 'break-word',
									width: '95%',
								}}
							>
								{workout.description}
							</div>
						</div>
					</div>
					<div
						style={{
							width: '100%',
							paddingBottom: 15,
						}}
					>
						<SequenceList
							// openVideoOverlay={(url) => this.openVideoOverlay(url)}
							changeParentImage={this.changeParentImage}
							sequences={Object.values(sequences)}
							circuits={circuits}
							plans={plans}
							workout={workout}
							planNotes={planNotes}
							isViewNotes={isViewNotes}
						/>
					</div>
				</div>
			);
		} else {
			return null;
		}
	}
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/workouts/Info.js